<nz-input-group
  [nzSuffix]="suffixIconSearch"
  [nzAddOnBefore]="searchByList.length ? prefixButton : ''"
>
  <input
    type="text"
    nz-input
    [placeholder]="placeholder"
    [style.width.px]="width"
    [(ngModel)]="value"
    (ngModelChange)="onChange($event)"
    [nzAutocomplete]="auto"
  />
  <nz-autocomplete
    #auto
    [compareWith]="compareFn"
    [nzDefaultActiveFirstOption]="false"
  >
    <nz-auto-option
      *ngFor="let option of options"
      [nzValue]="option"
      [nzLabel]="option.label"
    >
      {{ option.label }}
    </nz-auto-option>
  </nz-autocomplete>
</nz-input-group>
<ng-template #suffixIconSearch>
  <i nz-icon nzType="search" *ngIf="!value"></i>
  <i
    nz-icon
    class="ant-input-clear-icon"
    nzTheme="fill"
    nzType="close-circle"
    *ngIf="value"
    (click)="onClearValue()"
  ></i>
</ng-template>
<ng-template #prefixButton>
  <nz-select
    nzSize="large"
    [(ngModel)]="searchBy"
    (ngModelChange)="onSearchByChange($event)"
  >
    <nz-option
      *ngFor="let searchParam of searchByList"
      [nzLabel]="searchParam.label | translate"
      [nzValue]="searchParam.value"
    ></nz-option>
  </nz-select>
</ng-template>
